import { useEffect } from 'react';

const useFormatDisabledLimit = (
  disabled: boolean | undefined,
  backendLimit: number | undefined,
  setFieldValue: (val: string) => void
) => {
  useEffect(() => {
    if (disabled && backendLimit !== undefined && backendLimit !== -1) {
      setFieldValue(Number(backendLimit).toFixed(2));
    }
  }, [disabled, backendLimit, setFieldValue]);
};

export default useFormatDisabledLimit;
